import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const OutdoorworkService = {
  getOutdoorworkById(obj) {
    return httpClient.post(endPoints.getOutdoorworkById, obj);
  },
  getOutdoorworks() {
    return httpClient.post(endPoints.getOutdoorworks);
  },
  deleteOutdoorwork(obj) {
    return httpClient.post(endPoints.deleteOutdoorwork, obj);
  },
  finishOutdoorwork(obj) {
    return httpClient.post(endPoints.finishOutdoorwork, obj);
  },
  addOutdoorwork(obj) {
    return httpClient.post(endPoints.addOutdoorwork, obj);
  },
  modifyOutdoorwork(obj) {
    return httpClient.post(endPoints.modifyOutdoorwork, obj);
  }
};

export default OutdoorworkService;



// WEBPACK FOOTER //
// ./src/service/OutdoorworkService.js